import React from 'react';
import {Header} from '@/components';
import {screenSize} from '@/theme';
import {Images, LandingPageContent} from '@/constants';
import {Icon, Text, Button} from '@/ui-kits';
import {useWindowDimensions} from '@/hooks';

interface HeroProps {
  id?: string;
  openModal?: () => void;
}
export const Hero: React.FC<HeroProps> = ({id, openModal}) => {
  const {width} = useWindowDimensions();
  return (
    <header
    id={id}
    className="relative flex flex-col lg:p-4 mb-4 bg-cover bg-center"
    style={{
      backgroundImage:
        width <= screenSize.sm ? 'none' : `url(${Images.bg_hero})`,
    }}>
      <div
        className={`max-w-[1440px] flex flex-col items-center self-center z-10`}>
        <Header
          variant="home"
          cta={LandingPageContent.hero.header.cta as any}
        />
        <div className="grid grid-row-2 2xl:grid-row-1 2xl:grid-cols-2 px-2 w-full gap-6 2xl:gap-12 2xl:mt-10">
          {/* body */}
          <div className="flex flex-col gap-4">
            {/* features */}
            <div className="flex items-center justify-evenly w-full sm:w-fit gap-1 sm:gap-4 mt-2 xl:mt-0 flex-wrap">
              {LandingPageContent.hero.body.features.map(item => (
                <div key={item.title} className="flex items-center gap-1">
                  <Icon type={item.icon} className="size-2.5 sm:size-5" />{' '}
                  <p className="text-[10px] xs:text-xs sm:text-sm font-FigtreeSemiBold text-black">
                    {item.title}
                  </p>
                </div>
              ))}
            </div>
            <h1 className="text-ui_blue text-2xl sm:text-3xl 2xl:text-6xl font-FigtreeBold leading-tight break-words">
              {LandingPageContent.hero.body.main}
            </h1>
            <p className="text-ui_blue opacity-80 text-xs sm:text-sm 2xl:text-xl font-FigtreeSemiBold break-words">
              {LandingPageContent.hero.body.sub}
            </p>

            {/* buttons */}
            <div className="flex flex-col gap-2 2xl:gap-4 w-full sm:max-w-[360px] lg:max-w-[400px] self-center sm:self-start mt-4">
              <div className="flex flex-row gap-2 w-full">
                <Button
                  rightIcon="arrow_circle_white_right"
                  title="Upload your Report"
                  variant="primary"
                  onClick={openModal}
                  className="flex-1 whitespace-nowrap"
                  textClassName="whitespace-nowrap"
                />
                <a href="#service" className="flex-1">
                  <Button title="Learn More" variant="secondary" className="w-full" />
                </a>
              </div>

              <div className="flex items-center gap-2 2xl:gap-6 rounded-rounded-lg justify-center py-3 px-4 bg-ui_blue_medium">
                <Icon type="shield" className="size-5" />
                <Text
                  id="gradient-text-2"
                  className="text-sm font-FigtreeSemiBold">
                  Trusted by 10,000+ patients
                </Text>
              </div>
            </div>
          </div>

          {/* medical reports */}
          <div
            style={{boxShadow: '0px 2px 21px 0px rgba(0, 0, 0, 0.25)'}}
            className="rounded-3xl flex flex-col bg-white">
            <h2 className="border-b-[1px] p-4 text-ui_blue text-base 2xl:text-2xl font-FigtreeBold ml-4">
              {LandingPageContent.hero.medical_reports.title}
            </h2>

            {LandingPageContent.hero.medical_reports.steps.map(
              (item, index) => (
                <div key={item.title} className="flex p-4 items-center gap-2">
                  <img
                    alt={`medical-report-${index}`}
                    src={item.image}
                    className="size-[24px] 2xl:size-[40px] ml-4"
                  />
                  <div className="flex flex-col gap-[-1px] grow">
                    <p className="text-sm 2xl:text-[18px] font-FigtreeSemiBold text-ui_blue">
                      {item.title}
                    </p>
                    <p className="text-xs 2xl:text-sm font-FigtreeRegular text-ui_blue opacity-60">
                      {item.summary}
                    </p>
                  </div>

                  <div className="border-[1px] border-ui_blue_light rounded-rounded-lg p-1 mr-4">
                    <Icon type="check_mark" className="size-3 2xl:size-5" />
                  </div>
                </div>
              ),
            )}

            <img
              alt="medical-report-gif"
              src={LandingPageContent.hero.medical_reports.gif}
              className="self-stretch rounded-rounded-lg m-4"
            />
          </div>
        </div>
      </div>
    </header>
  );
};